/* eslint-disable no-mixed-operators */
import React from "react";
import { NavLink, Route, Switch } from "react-router-dom";
import { Button, Icon, Panel } from "@culturehq/components";

import VideoStudioContext from "components/stories/video-studio/contexts/VideoStudioContext";
import { useProfile } from "app/context";
import { Trans, t } from "app/utils";
import { isAdmin } from "app/permissions";

import StoriesPendingReview from "./settings/stories/StoriesPendingReview";
import StoriesApproved from "./settings/stories/StoriesApproved";
import StoriesInternal from "./settings/stories/StoriesInternal";
import StoriesPublished from "./settings/stories/StoriesPublished";
import StoriesJobMapping from "./settings/stories/StoriesJobMapping";
import StoriesArchived from "./settings/stories/StoriesArchived";

const SettingOption = ({ children, to, phrase }) => (
  <li role="navigation">
    <NavLink to={to} activeClassName="active">{phrase}{children}</NavLink>
  </li>
);

const CreateMontageAction = () => (
  <div className="StoryApprovals-Header-Container">
    <VideoStudioContext
      CustomButton={
        ({ onClick }) => (
          <Button onClick={onClick}>
            <Icon icon="plus" />
            <Trans>Create Montage</Trans>
          </Button>
        )
      }
      onStoryUpdate={() => {}}
      montage
    />
  </div>
);

const StoryApprovals = () => {
  const { profile } = useProfile();
  const { profile: { organization } } = useProfile();

  return (
    <Panel limitWidth>
      <ul role="tablist" aria-label={t("Story Approvals options")} className="nav nav-tabs StoryApprovals-Tabs">
        {isAdmin(profile) && (
          <SettingOption to="/admin/story-reviews/pending" phrase={t("Pending Review")}>
            {profile.pendingStoryReviews?.length > 0 && <em className="Notification-Badge">{profile.pendingStoryReviews.length}</em>}
          </SettingOption>
        )}
        <SettingOption to="/admin/story-reviews/approved" phrase={t("Approved")} />
        {organization.externalMappedIds && (
          <SettingOption to="/admin/story-reviews/mapped" phrase={t("Job Mappings")} />
        )}
        {isAdmin(profile) && (
          <>
            <SettingOption to="/admin/story-reviews/published" phrase={t("Published")} />
            <SettingOption to="/admin/story-reviews/internal" phrase={t("Internal Only")} />
            <SettingOption to="/admin/story-reviews/archived" phrase={t("Archived")} />
            <CreateMontageAction />
          </>
        )}
      </ul>
      <Panel.Body>
        <Switch>
          <Route exact path="/admin/story-reviews/pending/:page?" component={StoriesPendingReview} />
          <Route exact path="/admin/story-reviews/pending/story/:storyId" component={StoriesPendingReview} />
          <Route exact path="/admin/story-reviews/approved/:page?" component={StoriesApproved} />
          <Route exact path="/admin/story-reviews/approved/story/:storyId" component={StoriesApproved} />
          <Route exact path="/admin/story-reviews/mapped/:page?" component={StoriesJobMapping} />
          <Route exact path="/admin/story-reviews/mapped/story/:storyId" component={StoriesJobMapping} />
          <Route exact path="/admin/story-reviews/published/:page?" component={StoriesPublished} />
          <Route exact path="/admin/story-reviews/internal/:page?" component={StoriesInternal} />
          <Route exact path="/admin/story-reviews/internal/story/:storyId" component={StoriesInternal} />
          <Route exact path="/admin/story-reviews/archived/:page?" component={StoriesArchived} />
          <Route exact path="/admin/story-reviews/archived/story/:storyId" component={StoriesArchived} />
        </Switch>
      </Panel.Body>
    </Panel>
  );
};

export default StoryApprovals;
